import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useBoardConfigV1ControllerGet } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetBoardData = (constructionSiteId: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading, refetch } = useBoardConfigV1ControllerGet({
    pathParams: {
      constructionSiteId,
    },
    headers: restHeaders,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
